import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography } from '@mui/material';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// components
import { MIconButton } from '../../components/@material-extend';
import MyAvatar from '../../components/MyAvatar';
import MenuPopover from '../../components/MenuPopover';
import { analytics } from '../../contexts/FirebaseContext';
import useVersion from '../../hooks/useVersion';
import DialogReportTicket from '../../components/_dashboard/olimpo/tickets/components/DialogReportTicket';
import { actionSectionIdentifier, sectionIdentifier } from '../../constants/ticketsErrors';
import { analyticsEvents } from '../../constants/analyticsEvents';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Inicio',
    icon: homeFill,
    linkTo: '/',
    event: () => {
      analytics.logEvent(analyticsEvents.button_click_menu_home);
    }
  },
  // {
  //   label: 'Perfil',
  //   icon: personFill,
  //   linkTo: PATH_DASHBOARD.user.profile,
  //   event: () => {
  //     analytics.logEvent('button_click_menu_profile');
  //   }
  // },
  {
    label: 'Configuración',
    icon: settings2Fill,
    linkTo: PATH_DASHBOARD.user.account,
    event: () => {
      analytics.logEvent(analyticsEvents.button_click_menu_settings);
    }
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const { updateVersion } = useVersion();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      if (isMountedRef.current) {
        handleClose();
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout', { variant: 'error' });
    }
  };

  const ticketObj = { action: actionSectionIdentifier.manualAction, section: sectionIdentifier.accountPopover };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <MyAvatar />
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 220 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {user.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={() => {
              handleClose();
              option.event();
            }}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <MenuItem onClick={updateVersion} sx={{ typography: 'body2', py: 1, px: 2.5 }}>
          <Box
            component={Icon}
            icon="eva:refresh-fill"
            sx={{
              mr: 2,
              width: 24,
              height: 24
            }}
          />
          Actualizar pagina
        </MenuItem>

        <DialogReportTicket buttonType="menuItem" ticketObj={ticketObj} />

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={handleLogout}>
            Cerrar sesión
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
